import { SET_DETAIL_PROGRAM } from "../actions/action-types.js";

export default function detailProgram(state = {}, {type, payload}) {
    switch (type) {
        case SET_DETAIL_PROGRAM:
            return (state = payload)
        default:
            return state
    }
}